  import { useEffect, useState } from 'react';
  import LessonCard from '../components/LessonCard';
  import authAxios from '../auth/authAxios';
  import { CheckCircle2, Sparkles } from 'lucide-react';

  interface Lesson {
    lesson_id: string;
    title: string;
    description: string;
    completed: boolean;
    objective?: string;
    steps?: string;
    hint?: string;
    example_prompt?: string;
    max_score?: number;
  }

  const LessonPage = () => {
    const [lessonSummary, setLessonSummary] = useState<Lesson[]>([]);

    useEffect(() => {
      authAxios.get('/api/lessons/summary')
        .then(res => setLessonSummary(res.data))
        .catch(err => console.error('Failed to load lesson summary', err));
    }, []);

    if (!lessonSummary) return <p className="p-6">Loading lessons...</p>;

    return (
      <main className="max-w-[80vw] p-6">
        <div className="mt-6">
        <h2 className="text-3xl font-futuristic font-semibold mb-8 tracking-wide">Lessons</h2>
        {lessonSummary.length > 0 &&
          <div className="rounded-xl bg-gradient-to-br from-cyan-500/20 via-primary/10 to-transparent border border-primary/30 p-6 flex items-center justify-between gap-4 shadow-lg hover:shadow-xl transition mb-5">
            <div className="flex items-center gap-4">
              <img
                  src="/ai-12.png"
                  alt="Get Started!"
                  className="w-16 h-16 object-contain drop-shadow"
                />
              <div>
                <h4 className="text-xl font-semibold text-white mb-1">{lessonSummary.filter(l => !l.completed).length > 0 ? "Select a Lesson" : "You're all Caught Up!"}</h4>
                <p className="text-white/80 text-sm">
                {lessonSummary.filter(l => !l.completed).length > 0 ? "Click any Available Lesson to begin.  You can also select a Completed Lesson to try for a higher score." : "Congratulations!  You can click on any Completed Lesson to try for a higher score.  Check back soon for more Lessons."}
                </p>
              </div>
            </div>
            <div>&nbsp;</div>
          </div>
        }
                    <div className="flex flex-wrap gap-4">
              {lessonSummary.filter(l => !l.completed).map(l => (
                <LessonCard
                  id={l.lesson_id}
                  title={l.title}
                  description={l.description}
                  completed={l.completed}
              />
            ))}
            {lessonSummary.filter(l => l.completed).map(l => (
              <LessonCard
                id={l.lesson_id}
                title={l.title}
                description={l.description}
                completed={l.completed}
                highScore={l.max_score}
              />
            ))}
          </div>
        </div>
      </main>
    );
  };

  export default LessonPage;
